import { FiUsers, FiSettings } from 'react-icons/fi'

export const ADMIN_SECTION_ITEMS = [
  {
    id: 7,
    path: '/members',
    icon: <FiUsers />,
    title: 'Members',
  },
  {
    id: 8,
    path: '/settings',
    icon: <FiSettings />,
    title: 'Settings',
  },
]
